import React, { lazy } from 'react';
import { MapPinIcon, ClockIcon, PhoneIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Location() {
  return <section className="py-24 px-6 bg-white border-t border-grey-divider" data-id="element-190">
      <div className="max-w-[1800px] mx-auto" data-id="element-191">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-192">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-12" data-id="element-193">
            <div data-id="element-194">
              <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-6 block text-black/40" data-id="element-195">
                Our Presence
              </span>
              <h2 className="text-3xl md:text-4xl font-display font-bold mb-8 tracking-widest uppercase" data-id="element-196">
                The Alexandria Studio
              </h2>
              <p className="text-sm font-light tracking-widest text-black/70 leading-relaxed uppercase max-w-md" data-id="element-197">
                Experience the heritage and craftsmanship of Djili Creations in
                person. Our Alexandria studio offers bespoke consultations and
                exclusive collection previews.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-198">
              <div className="space-y-4" data-id="element-199">
                <div className="flex items-center space-x-3 text-black/40" data-id="element-200">
                  <MapPinIcon className="w-4 h-4" data-id="element-201" />
                  <span className="text-[9px] font-display uppercase tracking-widest" data-id="element-202">
                    Address
                  </span>
                </div>
                <p className="text-[11px] font-display font-bold tracking-widest uppercase leading-loose" data-id="element-203">
                  Alexandria, VA <br data-id="element-204" />
                  United States
                </p>
              </div>

              <div className="space-y-4" data-id="element-205">
                <div className="flex items-center space-x-3 text-black/40" data-id="element-206">
                  <ClockIcon className="w-4 h-4" data-id="element-207" />
                  <span className="text-[9px] font-display uppercase tracking-widest" data-id="element-208">
                    Hours
                  </span>
                </div>
                <p className="text-[11px] font-display font-bold tracking-widest uppercase leading-loose" data-id="element-209">
                  By Appointment Only <br data-id="element-210" />
                  Mon - Sat: 11AM - 6PM
                </p>
                <a href="tel:5718423307" className="text-[10px] font-display tracking-widest uppercase text-black/60 hover:text-black transition-colors block" data-id="element-211">
                  Call: (571) 842-3307
                </a>
              </div>
            </div>

            <Link to="/booking" className="inline-block bg-black text-white px-10 py-4 text-[10px] font-display font-bold uppercase tracking-widest hover:bg-black/80 transition-colors w-full md:w-auto text-center" data-id="element-212">
              Book a Consultation
            </Link>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative aspect-square md:aspect-video lg:aspect-square bg-grey-divider overflow-hidden grayscale contrast-125 border border-grey-divider" data-id="element-213">
            {/* Using a high-quality stylized map iframe for Alexandria, VA */}
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50000!2d-77.0469!3d38.8048!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7b0550993959d%3A0x643171850785132d!2sAlexandria%2C%20VA!5e0!3m2!1sen!2sus!4v1716200000000!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0,
            filter: 'grayscale(1) contrast(1.2) invert(0)'
          }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-214"></iframe>
            <div className="absolute inset-0 pointer-events-none border-[20px] border-white/10" data-id="element-215" />
          </motion.div>
        </div>
      </div>
    </section>;
}